export default "https://cdn-static.gokick.com/assets/f3c431ab621bc71377aad81f5421d83f1421a0d2/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";